import { type CancelledInvitation } from './api/hierarchy-api'

export function CancelledInvitationList({
  invitations,
  labelledBy,
}: {
  invitations: CancelledInvitation[]
  labelledBy: string
}) {
  const shown = invitations.filter((invitation) => invitation.invitedEmail !== null)
  const hidden = invitations.length - shown.length

  return (
    <ul
      aria-labelledby={labelledBy}
      className="text-muted-foreground ml-4 max-h-40 list-disc overflow-y-auto pl-4 text-sm"
    >
      {shown.map((invitation) => (
        <li key={invitation.invitationId}>{invitation.invitedEmail}</li>
      ))}
      {hidden > 0 && (
        <li>
          {hidden} {shown.length > 0 ? 'other ' : ''}pending invitation
          {hidden === 1 ? '' : 's'}
        </li>
      )}
    </ul>
  )
}
